import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BASE_URL from "../constent";
import imageCompression from "browser-image-compression";

export const fetchAllservices = createAsyncThunk(
  "ourServices/fetchAllservices",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/ourServices`);

      // console.log(response.data.data)
      return response.data.data;
    } catch (error) {
      if (error.response?.status === 404) {
        // The server returns 404 when there is no data
        return [];
      }

      return rejectWithValue(error.response?.data || "Failed to load requests");
    }
  }
);

export const AddService = createAsyncThunk(
  "ourServices/AddService",
  async ({ data }, { rejectWithValue }) => {
    try {
      // console.log(selectedSuperCategoryId)
      // console.log("🚀 Starting AddBrand function...");

      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const formData = new FormData();

      formData.append("title_en", data.nameEn);
      formData.append("title_ar", data.nameAr);
      formData.append("shortDes_en", data.descEn);
      formData.append("shortDes_ar", data.descAr);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append(
          "image",
          compressedFile,
          `ourServices-${Date.now()}.webp`
        );
      }

      // console.log("🧾 Sending Category with FormData...");

      const createResponse = await axios.post(
        `${BASE_URL}/ourServices`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token,
          },
        }
      );

      // console.log("✅ Brand created with image:", createResponse.data);

      return createResponse.data.data;
    } catch (error) {
      console.error("AddService failed:", error.message, error.response?.data);
      return rejectWithValue(error.response?.data || "Failed to add Service");
    }
  }
);

export const deleteServiceById = createAsyncThunk(
  "ourServices/deleteServiceById",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const response = await axios.delete(`${BASE_URL}/ourServices/${id}`, {
        headers: {
          token: token,
        },
      });

      // console.log("✅ Category deleted:", response.data);

      // Can we return the id to update the state in the reducer?
      return id;
    } catch (error) {
      console.error("Delete failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to delete Service"
      );
    }
  }
);

export const updateServiceById = createAsyncThunk(
  "ourServices/updateServiceById",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) throw new Error("No token found");

      const formData = new FormData();
      formData.append("title_en", data.nameEn);
      formData.append("title_ar", data.nameAr);
      formData.append("shortDes_en", data.descEN);
      formData.append("shortDes_ar", data.descAR);

      if (data.image instanceof File) {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
          fileType: "image/webp",
        };

        const compressedFile = await imageCompression(data.image, options);
        formData.append("image", compressedFile, `category-${Date.now()}.webp`);
      }

      const response = await axios.put(
        `${BASE_URL}/ourServices/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: token,
          },
        }
      );

      return response.data.updatedService || response.data;
    } catch (error) {
      console.error("Update failed:", error.message, error.response?.data);
      return rejectWithValue(
        error.response?.data || "Failed to update Service"
      );
    }
  }
);

const serviceSlice = createSlice({
  name: "ourServices",
  initialState: {
    allServices: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllservices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllservices.fulfilled, (state, action) => {
        state.loading = false;
        state.allServices = action.payload;
      })
      .addCase(fetchAllservices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default serviceSlice.reducer;

// Export actions and reducer
